import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType, QueryConfig } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { ReactivateDomains } from 'Types/Domain'

type GetDomainsResponse = {
  domains: Array<ReactivateDomains>
}

type QueryFnType = typeof getInactiveDomains

export const useGetInactiveDomains = (config?: QueryConfig<QueryFnType>) => {
  const { accountId, userId, subscriptionId } = useUserStore.getState()

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['inactiveDomains', userId],
    enabled: !!accountId && !!subscriptionId,
    queryFn: () => getInactiveDomains(userId, accountId),
    ...config,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data
  return { ...query, data }
}

const getInactiveDomains = async (userId: number, accountId: number) => {
  return await request<{ data: GetDomainsResponse }>({
    url: `users/${userId}/accounts/${accountId}/domains?inactiveOnly=true`,
    method: 'GET',
  })
}
